import { Component, Vue } from 'vue-property-decorator';
import WithRender from  './BulkTransactionsReport.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

@WithRender
@Component({
  filters:{
    formateDate(value: string)
    {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
    Datepicker
  },
})
export default class BulkTransactionsReport extends Vue {
  isLoading = false;
  fromDate= new Date();
  toDate = new Date();
  perPage =10;
  currentPage= 1;
  selectedPage =1;
  totalRecords= 0;
  bulkFile = '';
  description ='';
  items = [];
  fields = [
    {
      key: "targetNumber",
      label: "Receiver Number",
      sortable: true,
    },
    {
      key: "provider",
      label: "Provider",
      sortable: true,
    },
    {
      key: "status",
      label: "Status",
      sortable: true,
    },
    {
      key: "failedReason",
      label: "Failed Reason",
      sortable: true
    },
    {
      key: "createdOn",
      label: "Uploaded At",
      sortable: true,
    },
    {
      key: "updatedOn",
      label: "Updated At",
      sortable: true,
    }
  ]

  mounted () {
    this.bulkFile = this.$route.query.b as string;
    this.description = this.$route.query.d as string;
    this.getReport();
   }  

   handlePageClick(){
     if(this.currentPage === this.selectedPage)
        return;
      this.currentPage = this.selectedPage;
      this.getReport()
      }  

  getReport():void
  {
    this.isLoading = true;
    _axios.get(`${config.gateway}bulk/Report/Transactions?masterId=${this.bulkFile}&currentPage=${this.currentPage}&PageSize=${this.perPage}`)
    .then(response=>
    {
      console.log(this.items);
      this.items = response.data.transactions;
      this.totalRecords =response.data.totalRowCount;
    })
    .catch(err=>{console.error(err);})
    .finally(() => {
      this.isLoading = false;
    });
  }
}
